export const COMPANY_BASIC_DETAILS_REQUEST = "COMPANY_BASIC_DETAILS_REQUEST"
export const COMPANY_BASIC_DETAILS_SUCCESS = "COMPANY_BASIC_DETAILS_SUCCESS"
export const COMPANY_BASIC_DETAILS_FAIL = "COMPANY_BASIC_DETAILS_FAIL"